import { Button, makeStyles, useMediaQuery } from '@material-ui/core'
import Icon from '@mdi/react';
import React from 'react'
import { Link } from 'react-router-dom';


function Introduction() {

    const mobile = useMediaQuery('(max-width: 500px)');
    const styles = useStyles({ mobile });

    return (
        <section id="home" className={styles.introductionContainer}>
            <div className={styles.left}>
                <div className={styles.buttonContainer}>
                    <Link to='/neonatal' className={styles.link}>
                        <Button
                            type="submit"
                            variant='contained'
                            color='primary'
                            className={styles.button}
                            classes={{
                                label: styles.label
                            }}
                            fullWidth
                        >Neonatal Assessment Sheet</Button>
                    </Link>
                    <Button
                        type="submit"
                        variant='contained'
                        color='primary'
                        className={styles.button}
                        classes={{
                            label: styles.label
                        }}
                        fullWidth
                    >Coming Soon</Button>
                    <Button
                        type="submit"
                        variant='contained'
                        color='primary'
                        className={styles.button}
                        classes={{
                            label: styles.label
                        }}
                        fullWidth
                    >Coming Soon</Button>
                </div>
            </div>
        </section >
    )
}

export default Introduction

const useStyles = makeStyles(({
    introductionContainer: ({ mobile }) => mobile ? {
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '70px',
        textAlign: 'center'
    } : {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '50px'
    },
    left: ({ mobile }) => mobile ? {
        padding: '20px'
    } : {
        // border: '2px solid black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        margin: '20px',
        padding: '20px 60px'
    },
    button: ({ mobile }) => mobile ? {
        marginBottom: '25px',
        padding: '9px',
        backgroundColor: '#DB5461',
        borderRadius: '20px',
        transition: 'all 0.5s ease-in-out',
        boxShadow: '0 3px 10px 2px #CECECA',
        '&:hover': {
            backgroundColor: '#CA2B3B',
            transform: 'translateY(-5px)'
        }
    } : {
        // width: '70%',
        marginRight: '30px',
        marginBottom: '25px',
        padding: '9px',
        backgroundColor: '#DB5461',
        borderRadius: '20px',
        transition: 'all 0.5s ease-in-out',
        boxShadow: '0 3px 10px 2px #CECECA',
        '&:hover': {
            backgroundColor: '#CA2B3B',
            transform: 'translateY(-5px)'
        }
    },
    label: {
        fontWeight: '600'
    },
    link: {
        color: '#fefefe',
        textDecoration: 'none'
    }
}))
